import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './sidebar.css';
import { fetchReviews } from '../../redux/reviewsSlice';

const Sidebar = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch(); 
  const [sp] = useSearchParams();
  const type = sp.get('type') ?? 'group'; 
  const isPrivate = type === 'private';

  // Get reviews data from Redux
  const reviews = useSelector((state) => state.reviews.reviews);

  // Calculate unique product codes
  const productCodes = Array.from(new Set((reviews || []).map((review) => review[6]?.trim()).filter(Boolean)));

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  // Preserve current ?type on every navigation
  const go = (pathname) => navigate({ pathname, search: `?type=${type}` });
  const handleProductClick = (code) => go(`/products/${code}`);
  const handleOverviewClick = () => go('/');
  const handleGuideListClick = () => go('/guides');
  const handleFilterClick = () => go('/dashboard');

  // Switch data source and always go to homepage
  const switchTo = (next) => {
    navigate({ pathname: '/', search: `?type=${next}` });
    dispatch(fetchReviews(next)); // <-- trigger fetch only on type switch
  };

  return (
    <div className="sidebar">
      <div className="logo">
        <img src="/rosologo.webp" alt="logo" className="dash-icon" width={'150px'} />
      </div>

      <div className="source-toggle" role="group" aria-label="Data source">
        <button
          className={`toggle-btn ${!isPrivate ? 'active' : ''}`}
          onClick={() => switchTo('group')}
          aria-pressed={!isPrivate}
        >
          Group
        </button>
        <button
          className={`toggle-btn ${isPrivate ? 'active' : ''}`}
          onClick={() => switchTo('private')}
          aria-pressed={isPrivate}
        >
          Private
        </button>
      </div>

      <div className="heading">
        <img src="/Dash_main icon.svg" alt="Dash" className="dash-icon" />
        <div>Dashboard</div>
      </div>

      <ul>
        <li onClick={handleOverviewClick}>
          <img src="/overview.png" alt="Overview" className="sidebar-icon" />
          Overview
        </li>
        <li onClick={toggleDropdown} className="dropdown">
          <img src="/Products_icon_2.svg" alt="Products" className="sidebar-icon" />
          Products
          <span className="arrow">{isDropdownOpen ? '▲' : '▼'}</span>
        </li>
        {isDropdownOpen && (
          <ul className="dropdown-menu">
            {productCodes
              .slice()
              .sort((a, b) => a.localeCompare(b))
              .map((code) => (
                <li key={code} onClick={() => handleProductClick(code)}>
                  {code}
                </li>
              ))}
          </ul>
        )}
        <li onClick={handleGuideListClick}>
          <img src="/avatar.png" alt="Guide List" className="sidebar-icon" />
          Guide List
        </li>
        <li onClick={handleFilterClick}>
          <img src="/filter.png" alt="Filter" className="sidebar-icon" />
          Filter
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
